import { STRIPE } from '../../constants';
import { INVOICE_BALANCE_INCOMING_KEYS } from '../../constants/Invoice';

export const orderLines = <T extends { key?: string }>(
    lines: T[]
): T[] =>
    [...(lines ?? [])].sort((a, b) =>
        (a.key ?? '').toLowerCase().localeCompare((b.key ?? '').toLowerCase())
    );

export const isPaymentType = (key?: string) => (key ?? '').toLowerCase() === STRIPE;

export const mapIncomingKeyToName = (key: string): string => {
    switch (key) {
        case INVOICE_BALANCE_INCOMING_KEYS.TOTAL:
            return 'TOTAL'
        case INVOICE_BALANCE_INCOMING_KEYS.CB:
            return 'via Terminal'
        case INVOICE_BALANCE_INCOMING_KEYS.CASH:
            return 'via Espèces'
        case INVOICE_BALANCE_INCOMING_KEYS.STRIPE:
        default:
            return 'via Paiement en ligne';
    }
}